export default "__VITE_ASSET__BimU5xvE__"